import reportService from "../services/reports/index";

export default {
  install(Vue) {
    Vue.prototype.$reports = reportService;
  }
};
